<template>
  <div class="page">
    <p class="p1">支付完成</p>
    <p class="p2">温馨提示：</p>
    <p class="p3">为方便您后续用卡方便，建议您长按下方图片识别关注公众号</p>
    <div class="img_class">
      <img src="../assets/img/ggh.jpg" alt="">
    </div>
    <nut-button block @click="toDetails">返回详情</nut-button>

  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    // 返回详情
    toDetails(){
      this.$router.push({
        name: "info",
        query: {
          iccid: this.$route.query.iccid,
        }
      });
    }
  },
  created() {

  },
  mounted() {

  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      width: 100%;
      height: 120px;
      line-height: 120px;
      text-align: center;
      font-size: 28px;
      background:linear-gradient(#FFCC99,#FF9966,#FD986E);
      color: #fff;
      font-weight: 400;
    }
    .p2{
      width: 100%;
      padding: 10px;
    }
    .p3{
      width: 100%;
      padding: 0 10px;
    }
    .img_class{
      margin-top: 30px;
      width: 100%;
      text-align: center;
      img{
        width: 200px;
        height: 190px;
      }
    }
    /deep/ .nut-button.block{
      margin-top: 25px;
      width:90%;
      margin-left: 5%;
      height: 45px;
      font-size: 16px;
      border-radius:5px;
      background: #FD986E;
    }
  }
</style>

